import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomBoard from "../../../../components/CustomBoard";
import "fontsource-muli";
import CustomButton from "../../../../components/CustomButton";
import { withRouter } from "react-router-dom";

class ReceivedGenericLinkOtp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      
      height: 0,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    window.scrollTo(0, 0);
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ height: window.innerHeight });
  }

  onClickReturnToLogin = () => {
    const {history} = this.props;
    history.push("/")
    window.location.reload(false);
  };

  renderChildren = () => {
    const { classes } = this.props;
    
    
    return (
      <div>
        <CustomText design={classes.headerTextStyle}>Congratulations! You have successfully activated your account.</CustomText>
        <div className={classes.userIDContainer}>
        <CustomButton
          title={"Click here to login"}
          design={classes.buttonStyle}
          onClick={this.onClickReturnToLogin}
        />
        </div>

       
      </div>
    );
  };

  render() {
    const { classes } = this.props;
    const { height } = this.state;
    return (
      <div className={classes.root}>
        <CustomBoard children={this.renderChildren()} height={height} />
      </div>
    );
  }
}

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: "white",
  },
  headerTextStyle: {
    ...getFontWeight("800"),
    fontSize: 28,
    textAlign: "left",
    color: "#2c3034",
  },
 userIDContainer:{
   
   marginTop: 35,
   marginBottom: 35,
   
   paddingRight: 20,
   paddingTop: 5,
   paddingBottom: 5
 },
  userIDTextStyle:{
    fontSize: 21,
    ...getFontWeight("bold"),
    color: "#2c3034"
  },
  buttonStyle: {
    width: 200,
  },
});

export default withStyles(styles, { withTheme: true })(
  withRouter(ReceivedGenericLinkOtp)
);
